import { type UrlEntry, type UrlRegion } from '@/types';

export const isIndexable = false;

export const urls: Record<'quiz', Partial<Record<UrlRegion, UrlEntry>>> = {
  quiz: {
    de: 'quiz',
    'de-en': 'quiz',
    es: 'quiz',
    'es-en': 'quiz',
    fr: 'quiz',
    'fr-en': 'quiz',
    pt: 'quiz',
    'pt-en': 'quiz',
  },
};
